export const allowedImagesTypesValues = ['image/jpeg', 'image/png']
export const allowedDocumentsTypesValues = [
  ...allowedImagesTypesValues,
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]
